import {
	CancelProductOperationRequest,
	ProductOperationDomain,
	ProductTechMapResponse,
	useCancelOperationMutation,
} from '@/shared/state/api/swagger';
import { useUpdateOperations } from '@/widgets/operation/hooks';
import { CancelOperationFormBase } from './cancel-operation-form-base';
import { BaseCancelOperationFormProps, CancelOperationConfig } from './cancel-operation-form.types';

const productOperationConfig: CancelOperationConfig<
	ProductOperationDomain,
	ProductTechMapResponse,
	CancelProductOperationRequest
> = {
	useCancelMutation: () => {
		const [cancelOperation, meta] = useCancelOperationMutation();
		return [
			(params: { cancelRequest: CancelProductOperationRequest }) =>
				cancelOperation({ cancelProductOperationRequest: params.cancelRequest }),
			meta,
		];
	},

	useUpdateOperations: (techMapId: number) => useUpdateOperations(techMapId),

	buildCancelPayload: (operation, employeeFio) => ({
		closing_employee_fio: employeeFio,
		product_operation_id: operation.id!,
	}),

	getOperationTitle: (operation) => String(operation.name || ''),
	getOperationStepId: (operation) => operation.step_id,
	getOperationId: (operation) => operation.id,
	getTechMapId: (techMap) => Number(techMap.id),
	getTechMapNumber: (techMap) => Number(techMap.number),

	markOperationCanceled: (operation, date) => ({
		...operation,
		date,
		is_canceled: true,
	}),

	markOperationNotCanceled: (operation, date) => ({
		...operation,
		date,
		is_canceled: false,
	}),

	getOperationCanceledStatus: (operation) => Boolean(operation.is_canceled),
};

export type ProductCancelOperationFormProps = BaseCancelOperationFormProps<
	ProductOperationDomain,
	ProductTechMapResponse
>;

export const ProductCancelOperationForm = (props: ProductCancelOperationFormProps) => {
	return <CancelOperationFormBase {...props} config={productOperationConfig} />;
};
